import styled from 'styled-components'

export const StaticIndicator = styled.div`
	width: 12px;
	height: 12px;
	border-radius: 100%;
	background-color: currentColor;
	margin: 6px 6px 9px;
	flex-grow: 0;
	flex-shrink: 0;
`
